module.exports = __webpack_public_path__ + "media/images/icons/outlined/undo-3514b56d318734d3ebab2312871b7d3c.svg";